import React, { useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from "react-i18next";
import AOS from 'aos';

import 'aos/dist/aos.css';
import './ChiSiamo.css';

function ChiSiamo() {
    const { t } = useTranslation();

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    // Memoizza JSON-LD per evitare warning su t() in JSX
    const jsonLd = useMemo(() => ({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Andromeda Programmazione",
        "url": "https://www.andromedaprog.it",
        "sameAs": [
            "https://www.facebook.com/andromeda",
            "https://www.instagram.com/andromeda",
            "https://www.linkedin.com"
        ],
        "description": t("chiSiamoPage.seoDescrizione"),
        "contactPoint": {
            "@type": "ContactPoint",
            "email": "info@andromedaprog.it",
            "contactType": "Customer Service",
            "areaServed": "IT"
        },
        "founder": { "@type": "Person", "name": "Vito Patruno" },
        "address": { "@type": "PostalAddress", "addressLocality": "Lecce", "addressCountry": "IT" }
    }), [t]);

    return (
        <section className="about-page py-5 text-dark">
            <Helmet>
                <title>{t("chiSiamoPage.seoTitolo")}</title>
                <meta name="description" content={t("chiSiamoPage.seoDescrizione")} />
                <meta name="keywords" content={t("chiSiamoPage.seoKeywords")} />
                <meta name="author" content="Andromeda Programmazione" />
                <link rel="canonical" href="https://www.andromedaprog.it/chi-siamo" />

                <meta property="og:title" content={t("chiSiamoPage.ogTitolo")} />
                <meta property="og:description" content={t("chiSiamoPage.ogDescrizione")} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.andromedaprog.it/chi-siamo" />
                <meta property="og:image" content="/images/chi-sono.png" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={t("chiSiamoPage.twitterTitolo")} />
                <meta name="twitter:description" content={t("chiSiamoPage.twitterDescrizione")} />
                <meta name="twitter:image" content="/images/chi-sono.png" />

                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            </Helmet>

            <div className="container">
                <div className="row align-items-center mb-5" data-aos="fade-up">
                    <div className="col-md-6">
                        <h1 className="fw-bold text-primary mb-4">{t("chiSiamoPage.titolo")}</h1>
                        <p className="lead">{t("chiSiamoPage.introduzione")}</p>

                        <h2 className="h5 mt-4">{t("chiSiamoPage.cosaFacciamoTitolo")}</h2>
                        <p>{t("chiSiamoPage.cosaFacciamoTesto")}</p>

                        <p>{t("chiSiamoPage.tecnologieTesto")}</p>
                        <p>{t("chiSiamoPage.esperienzaTesto")}</p>
                    </div>

                    <div className="col-md-6 text-center" data-aos="fade-left">
                        <img
                            src="/images/chi-sono.png"
                            alt={t("chiSiamoPage.imgAlt")}
                            className="img-fluid rounded shadow-lg"
                        />
                    </div>
                </div>

                <div className="text-center" data-aos="fade-up">
                    <h2 className="fw-bold text-primary mt-4">{t("chiSiamoPage.missionTitolo")}</h2>
                    <p className="mt-3">{t("chiSiamoPage.missionTesto")}</p>

                    <a
                        href="mailto:info@andromedaprog.it"
                        className="btn btn-primary mt-4"
                        aria-label={t("chiSiamoPage.contattamiAlt")}
                    >
                        {t("chiSiamoPage.contattami")}
                    </a>
                </div>
            </div>
        </section>
    );
}

export default ChiSiamo;
